import { Dispatch } from 'redux'

import { latestJobRun } from 'redux/api/DataSettings'

import * as actions from './actions'

export function tryGetLatestJobRun(dispatch: Dispatch) {
  dispatch(actions.getLatestJobRun())

  latestJobRun()
    .then((response) => {
      dispatch(actions.getLatestJobRunSuccess(response.data.data))
    })
    .catch(() => {
      dispatch(actions.getLatestJobRunFailed())
    })
}
